__webpack_require__.p = "https://beta.jp.safer.whs.amazon.dev/";